export default __webpack_public_path__ + "static/media/logo-tagline.bc6d06f8.svg";